export function useInfoBoxTransitions() {
  const startExpandTransition = (element: HTMLElement) => {
    const contentSection = element.firstElementChild as HTMLElement
    const sectionHeight = contentSection.offsetHeight

    element.style.height = '0'
    element.style.opacity = '0'
    element.style.overflow = 'hidden'

    void element.offsetHeight

    element.style.height = `${sectionHeight}px`
    element.style.opacity = '1'
  }

  const endExpandTransition = (element: HTMLElement) => {
    element.style.height = ''
    element.style.overflow = ''
  }

  const startCollapseTransition = (element: HTMLElement) => {
    const contentSection = element.firstElementChild as HTMLElement
    if (!contentSection) return

    const sectionHeight = contentSection.offsetHeight

    element.style.height = `${sectionHeight}px`
    element.style.overflow = 'hidden'
    element.style.opacity = '1'

    void element.offsetHeight

    requestAnimationFrame(() => {
      element.style.height = '0'
      element.style.opacity = '0'
    })
  }

  const endCollapseTransition = (element: HTMLElement) => {
    element.style.height = ''
    element.style.overflow = ''
    element.style.opacity = ''
  }

  return {
    startExpandTransition,
    endExpandTransition,
    startCollapseTransition,
    endCollapseTransition,
  }
}
